import React, { useContext } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './Center.css';
import MainPageBlock from './MainPageBlock/MainPageBlock';

import Calendar from '../../Calendar/Calendar'
const Center = ({ performance, loading }) => {
    return (
        <>
            <div className='center'>
			 {/*<Calendar />*/}
             <MainPageBlock title={'Успеваемость'} cardType={'course'} data={performance} link={'/performance'} loading={loading}/>

            </div>

        </>
    )
}
export default Center
